<template>
  <div>
    <div v-if="!entries.length" class="text-caption empty">Sin cambios registrados.</div>
    <div v-for="(entry, index) in entries" :key="index" class="entry">
      <div class="entry-rail">
        <span class="entry-dot" :style="{ background: entry.color }"></span>
        <div v-if="index < entries.length - 1" class="entry-line"></div>
      </div>
      <div class="entry-body">
        <span class="entry-label">
          {{ entry.label }} <span class="entry-date">— {{ entry.date }}</span>
        </span>
        <span v-if="entry.detail" class="entry-detail">{{ entry.detail }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { timelineEntries } from '@/utils/clinic-settlements.utils';

// "Historial de cambios" del detalle, del más nuevo al más antiguo, con autor.
export default {
  name: 'SettlementHistoryTimeline',
  props: {
    events: { type: Array, default: () => [] }
  },
  computed: {
    entries() {
      return timelineEntries(this.events);
    }
  }
};
</script>

<style scoped>
.entry {
  display: flex;
  gap: 10px;
}
.entry-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 8px;
}
.entry-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  flex-shrink: 0;
  margin-top: 5px;
}
.entry-line {
  width: 2px;
  flex-grow: 1;
  background: var(--pw-border);
  margin-top: 2px;
}
.entry-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 12px;
}
.entry-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--pw-text);
}
.entry-date,
.entry-detail,
.empty {
  font-weight: 400;
  font-size: 12px;
  color: var(--pw-text-muted);
}
</style>
